import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { ProfileRolesItem } from '../profile-roles-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { JobSummaryProps as Props } from './types';

export const JobSummary = memo(
  ({ className, isMainPage, currentRoles }: Props) => {
    if (!currentRoles || currentRoles.length === 0) return null;

    return (
      <Styled.Wrapper
        className={classnames('JobSummary', className)}
        sx={SX.root}
      >
        {currentRoles.map((companyData, companyIndex) => (
          <ProfileRolesItem
            key={companyIndex}
            companyData={companyData}
            isMainPage={isMainPage}
          />
        ))}
      </Styled.Wrapper>
    );
  }
);

JobSummary.displayName = 'JobSummary';
